import { Component, Input, OnInit } from '@angular/core';
import { ItineraryResult } from 'src/app/shared/models/itinerary-result.interface';
import { ConfigService } from 'src/app/shared/services/config.service';

@Component({
	selector: 'app-itinerary-result',
	templateUrl: './itinerary-result.component.html'
})
export class ItineraryResultComponent implements OnInit {

	@Input() itineraryResult: ItineraryResult = null;
	@Input() first: boolean = null;
	@Input() last: boolean = null;

	constructor(
		private _configService: ConfigService
	) { }

	ngOnInit(): void {
		//console.log('ItineraryResultComponent.ngOninit');
		//console.log('ItineraryResultComponent.itineraryResult:', this.itineraryResult);
		// console.log('ItineraryResultComponent.first:', this.first);
		// console.log('ItineraryResultComponent.last:', this.last);
	}

}
